export const StorageKey = {
  PROJECT_ID: 'ezrevenue_project_id',
  MERCHANT_TOKEN: 'm_token',
  CUSTOMER_TOKEN_PREFIX: 'c_token__',
}
